var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"nameList"},_vm._l((_vm.data),function(item,index){return _c('div',{key:'cityUserCount'+index},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.py))])}),0),_c('div',{staticStyle:{"width":"290px","height":"280px"},attrs:{"id":"chartUserCityNumber"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }